import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';

export const styleFn: ThemedStyleFn = (theme) => ({
  alignCenterWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 20px',
  },
  // Primary-/Secondary Share Keys (vendor tab) - Invite modal form fields.
  formField: {
    marginBottom: 16,
  },
  fieldLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: '#595959',
    marginBottom: 4,
  },
  table: {
    '.ant-table-row': {
      animation: `${fadeInKeyframes} 0.3s ease-out`,
      cursor: 'pointer',

      '&.unfinished > td': {
        color: 'rgba(0, 0, 0, 0.25)',
      },
    },
    // Primary-/Secondary Share Keys: pairs with expandable.columnWidth (40)
    // above - centers the +/- button within its own narrow column instead
    // of it hugging the cell's left edge. `text-align: center` alone isn't
    // enough because antd's own base styles set `.ant-table-row-expand-icon`
    // to `float: left`, and floated elements ignore the parent's
    // text-align - so we also have to cancel that float out here.
    '.ant-table-row-expand-icon-cell': {
      textAlign: 'center',
      '.ant-table-row-expand-icon': {
        float: 'none',
      },
    },
  },

  tagPoint: {
    width: 15,
    height: 15,
    borderRadius: 10,
  },
  // tag color-related styles
  yellow: {
    backgroundColor: theme.colors.yellow,
  },
  green: {
    backgroundColor: theme.colors.green,
  },
  lightGray: {
    backgroundColor: theme.colors.lightGray,
  },
  gray: {
    backgroundColor: theme.colors.gray,
  },
  red: {
    backgroundColor: theme.colors.red,
  },
  black: {
    backgroundColor: theme.colors.darkGray,
  },
  transparent: {
    border: `1px solid ${theme.colors.lightGray}`,
  },
  orange: {
    backgroundColor: '#FFA500',
  },
  blue: {
    backgroundColor: '#00ffea',
  },
  purple: {
    backgroundColor: '#800080',
  },
  grey: {
    backgroundColor: '#808080',
  },
});
